export default __webpack_public_path__ + "static/media/danger.d10172d6.svg";